import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API, auth, C, SERIF, SANS } from "./CoachBits";
import { coachTheme, coachThemeVars } from "./coachTheme";

// Entry card into a space's Reclaim guide (only shown to people the guide is open to).
export const GuideEntry = ({ coach, to, label }) => {
  const nav = useNavigate();
  const [st, setSt] = useState(null);
  useEffect(() => { axios.get(`${API}/api/coach/${coach}/state`, auth()).then((r) => setSt(r.data)).catch(() => {}); }, [coach]);
  if (!st?.eligible) return null;
  const who = st.identities[st.who] || Object.values(st.identities)[0];
  const others = Object.entries(st.identities).filter(([k]) => !st.who || k === st.who);
  return (
    <button type="button" onClick={() => nav(to)} data-testid={`${coach}-guide-entry`}
      className="w-full rounded-3xl p-4 flex items-center gap-4 text-left transition-transform duration-300 hover:-translate-y-0.5"
      style={{ ...coachThemeVars(coach), background: coachTheme(coach).card, border: `1px solid ${C.line}` }}>
      <span className="flex -space-x-3 shrink-0">
        {others.map(([k, v]) => (
          <img key={k} src={v.image} alt={v.name} className="w-14 h-14 rounded-full object-cover object-top" style={{ boxShadow: `0 0 0 2px ${C.bg}` }} />
        ))}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <img src="/assets/reclaim-logo-white.png" alt="Reclaim" className="h-5 w-auto" />
          <span className="text-[0.55rem] uppercase tracking-[0.28em]" style={{ color: C.gold, fontFamily: SANS }}>{label} guide</span>
        </span>
        <span className="block mt-1 text-xl leading-tight" style={{ fontFamily: SERIF, color: C.cream }}>
          {st.who ? `Talk to ${who.name}` : "Meet your guide"}
        </span>
      </span>
      <ArrowRight size={18} style={{ color: C.gold }} />
    </button>
  );
};
